import styled from 'styled-components'
import { tokens } from 'styling/tokens'
import { IMetricCardWrapper, IMetricTrendProps } from 'types/ui/metricCard.interface'

export const MetricCardWrapper = styled.div<IMetricCardWrapper>`
  background: ${tokens.surface.glass};
  backdrop-filter: blur(${tokens.blur});
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.card};
  box-shadow: ${tokens.shadow.card};
  padding: ${tokens.space.md};
  min-height: 5.5rem;
  display: flex;
  flex-direction: ${(props) => (props.$layout === 'inline' ? 'row' : 'column')};
  align-items: ${(props) => (props.$layout === 'inline' ? 'center' : 'stretch')};
  justify-content: ${(props) => (props.$layout === 'inline' ? 'space-between' : 'flex-start')};
  gap: ${(props) => (props.$layout === 'inline' ? tokens.space.sm : '0.125rem')};
`

export const MetricCardBody = styled.div`
  display: flex;
  align-items: center;
  gap: ${tokens.space.sm};
  min-width: 0;
  flex: 1;
`

export const MetricTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  min-width: 0;
`

export const MetricCardTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const MetricValueRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: ${tokens.space.sm};
  width: 100%;

  ${MetricCardTop} + & {
    margin-top: ${tokens.space.xs};
  }
`

export const MetricTopRight = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: ${tokens.space.xs};
`

export const MetricIconChip = styled.div<IMetricCardWrapper>`
  width: 1.75rem;
  height: 1.75rem;
  border-radius: ${tokens.radius.chip};
  background: ${tokens.surface.inset};
  color: ${(props) => props.$accent || tokens.text.secondary};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  svg {
    width: 1rem;
    height: 1rem;
    fill: currentColor;
  }
`

export const MetricTrend = styled.span<IMetricTrendProps>`
  font-size: ${tokens.font.label};
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  color: ${(props) => (props.$positive ? tokens.status.success.fg : tokens.status.danger.fg)};
`

export const MetricValue = styled.div`
  font-size: ${tokens.font.display};
  font-weight: 500;
  color: ${tokens.text.primary};
  font-variant-numeric: tabular-nums;
`

export const MetricLabel = styled.div`
  font-size: ${tokens.font.label};
  font-weight: 700;
  color: ${tokens.text.muted};
`

export const MetricSublabel = styled.div`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
  margin-top: ${tokens.space.xs};
`
